export enum JobField {
  Id = 'id',
  Trigger = 'trigger',
  StartTime = 'start_time',
  EndTime = 'end_time',
  RunBy = 'run_by',
  Progress = 'progress',
  Status = 'status',
}

export enum NotificationField {
  Id = 'id',
  Subject = 'subject',
  Classification = 'classification',
  ProcessingStatus = 'processing_status',
  JobId = 'job_id',
  Timestamp = 'timestamp',
}
